import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "spr-subsidiaries",
  "use": "spr-subsidiaries-usage",
  "viewBox": "0 0 30 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 30 48\" id=\"spr-subsidiaries\">\r\n<polygon id=\"spr-subsidiaries_Page-1\" points=\"16.5,3 16.5,9 16.5,16 0,16 0,33 1.9,33 1.9,18 16.5,18 16.5,21 3.9,21 3.9,23 16.5,23 16.5,25 \r\n\t18.4,25 18.4,17.3 18.4,16 18.4,11.2 28.1,16.2 28.1,33 28.1,42 18.4,42 18.4,29 16.5,29 16.5,42 1.9,42 1.9,39 15.2,39 15.2,37 \r\n\t1.9,37 0,37 0,44 16.5,44 18.4,44 30,44 30,15 22.4,11 22.4,7 20.4,7 20.4,10 18.5,9 18.5,3 \" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ../img/sprite/subsidiaries.svg
// module id = 201
// module chunks = 0